import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PrintService {

  printContainer: HTMLDivElement;

  constructor() {

    this.printContainer = document.createElement("div");
    this.printContainer.className = "print-container container-fluid";
    window.document.body.appendChild(this.printContainer);
  }

  hasContent(): boolean {
    return this.printContainer.innerHTML != "";
  }

  reset() {
    this.printContainer.innerHTML = "";
  }

  addHeader(title: string): Promise<void> {
    let _h = document.createElement("header");
    this.printContainer.appendChild(_h);
    return new Promise((resolve, reject) => {
      let _logo = new Image();
      _logo.onload = (e: any) => {
        _h.appendChild(_logo);
        if (title != "") {
          let _t = document.createElement("h1");
          _t.innerHTML = title;
          _h.appendChild(_t);
        }
        resolve();
      };
      _logo.src = "assets/img/logo_brico.jpg";
      _logo.width = 176;
      _logo.height = 156;
    });
  }

  addImage(src: string): Promise<void> {
    let _i = new Image();
    _i.className = "img-fluid";
    this.printContainer.appendChild(_i);

    return new Promise((resolve, reject) => {
      _i.onload = (e: any) => {
        resolve();
      };
      _i.src = src;
    });

  }

  addPageBreak() {
    let _pb = document.createElement("div");
    _pb.className = "page-break-after";
    this.printContainer.appendChild(_pb);
  }

  addText(text: string, style: string) {
    let _p = document.createElement("p");
    _p.innerHTML = text;
    _p.className = style ? style : "";
    this.printContainer.appendChild(_p);
  }

  addDivPrice(div: HTMLDivElement): Promise<void> {
    const clonedDiv = div.cloneNode(true) as HTMLDivElement;
    clonedDiv.classList.add("price-table-container");
    return this.addDiv(clonedDiv);
  }

  addDiv(div: HTMLDivElement): Promise<void> {
    const clonedDiv = div.cloneNode(true) as HTMLDivElement;

    const fragment = document.createDocumentFragment();

    //pour chaque élément de la div, on exclue le bouton des services
    for (const child of Array.from(clonedDiv.children)) {

      if (child.classList.contains("pdf")) {
        child.classList.remove("hidden-object")
      }

      if (child.classList.contains("manage-service")) {
        child.classList.add("hidden-object")
      }
      if (child.classList.contains("qrcodeHeight")) {
        child.classList.remove("hidden-object")
      }
      fragment.appendChild(child.cloneNode(true));
    }

    clonedDiv.innerHTML = '';
    clonedDiv.appendChild(fragment);
    this.printContainer.appendChild(clonedDiv);

    return new Promise((resolve, reject) => {
      let _imgs = div.querySelectorAll("img");

      if (_imgs.length > 0) {

        let _imgToLoadCount = _imgs.length;
        let _imgLoaded = 0;

        for (let i = 0; i < _imgs.length; i++) {
          const _img: HTMLImageElement = _imgs[i];

          if (!_img.complete) {
            _img.onload = (e: any) => {
              _imgLoaded++;
              if (_imgLoaded === _imgToLoadCount) resolve();
            };
            _img.onerror = (e: any) => {
              _imgLoaded++;
              if (_imgLoaded === _imgToLoadCount) resolve();
            };
          } else {
            _imgLoaded++;
            if (_imgLoaded === _imgToLoadCount) resolve();
          }
        }
      } else {
        resolve();
      }

    });
  }

  addTable(table: HTMLTableElement, vendor?: boolean): Promise<void> {
    const clonedTable = table.cloneNode(true) as HTMLTableElement;
    clonedTable.classList.add("product-table");

    if (vendor) { //pour le vendeur, on remplace la colonne ref par la colonne barcode
      const fragment = document.createDocumentFragment();

      for (const child of Array.from(clonedTable.children)) {
        if (child.classList.contains('title-row')) {
          const secondTd = child.querySelector('td:nth-child(2)');
          if (secondTd) {
            secondTd.setAttribute('colspan', vendor ? '6' : '2');
          }
        }

        if (child.classList.contains('spacer')) {
          child.setAttribute('colspan', vendor ? '12' : '8');
        }

        const barcode = child.querySelectorAll(".hidden-object"); // pour démasquer la colonne code barre
        barcode.forEach(c => c.classList.remove("hidden-object"));

        const ref = child.querySelectorAll(".toHidePrint"); //pour masquer la colonne référence
        ref.forEach(c => c.classList.add("hidden-object"));
        fragment.appendChild(child.cloneNode(true));
      }

      clonedTable.innerHTML = '';
      clonedTable.appendChild(fragment);
      this.printContainer.appendChild(clonedTable);
    } else {
      this.printContainer.appendChild(clonedTable);
    }
    return new Promise((resolve, reject) => {

      let _imgs = clonedTable.querySelectorAll("img");

      if (_imgs.length > 0) {

        let _imgToLoadCount = _imgs.length;
        let _imgLoaded = 0;

        for (let i = 0; i < _imgs.length; i++) {
          const _img: HTMLImageElement = _imgs[i];
          if (_img.src.endsWith(".svg")) {
            _img.classList.add("svg-image"); // Ajouter une classe spéciale pour les images SVG pour diminuer leur taille
          }

          if (!_img.complete) {
            _img.onload = (e: any) => {
              _imgLoaded++;
              if (_imgLoaded === _imgToLoadCount) resolve();
            };
            _img.onerror = (e: any) => {
              _imgLoaded++;
              if (_imgLoaded === _imgToLoadCount) resolve();
            };
          } else {
            _imgLoaded++;
            if (_imgLoaded === _imgToLoadCount) resolve();
          }
        }
      } else {
        resolve();
      }
    });
  }

  addTitleRow(level: number, text: string) {
    let _t = document.createElement("h" + level);
    _t.innerHTML = text;
    _t.className = "bg-blue";
    this.printContainer.appendChild(_t);
  }

  print() {
    window.print();
  }
}
